// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import * as Focusable from 'common/util/focusable';

export interface BaseButtonAttrs {
  disabled?: boolean;
  elref?: string;
  'not-focusable'?: boolean;
  readonly?: boolean;
  'style-override'?: string;
}

export const baseButtonParams = {
  disabled: Boolean,
  elref: String,
  'style-override': String,
};

export class ButtonBase<AttrsT, ParamT = unknown, ContextRegistryT = unknown> extends Component<
  EmptyObj,
  BaseButtonAttrs & AttrsT,
  unknown,
  unknown,
  ContextRegistryT,
  ParamT
> {
  static get attrsSchema(): AttrsSchema<BaseButtonAttrs> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      elref: `string`,
      'not-focusable': `boolean`,
      readonly: `boolean`,
    };
  }

  get config() {
    return {
      defaultState: {},
      template: () => null,
      useShadowDom: true,
      helpers: {},
    };
  }

  get disabled() {
    return this.attr(`disabled`);
  }

  set disabled(disabled) {
    if (disabled) {
      this.setAttribute(`disabled`, ``);
    } else {
      this.removeAttribute(`disabled`);
    }
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    Focusable.handleAttributeChangedCallback(this, attr);
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute(`role`, `button`);
    this.addEventListener(`keydown`, this.handleKeyDown);

    Focusable.handleConnectedCallback(this);
  }

  disconnectedCallback() {
    this.removeEventListener(`keydown`, this.handleKeyDown);
    super.disconnectedCallback();
  }

  /** Enter and Space activate the focused host the way they activate a native button. */
  handleKeyDown = (ev: KeyboardEvent) => {
    if (ev.defaultPrevented || ev.composedPath()[0] !== this || this.attr(`disabled`) || this.attr(`not-focusable`)) {
      return;
    }
    if (ev.key === `Enter` || ev.key === ` `) {
      ev.preventDefault();
      this.getKeyboardActivationTarget().click();
    }
  };

  /** The element a keyboard activation clicks. Subclasses with a nested link activate that link. */
  protected getKeyboardActivationTarget(): HTMLElement {
    return this;
  }
}
